export const REGEX_VALUES = {
    LETTERS_ONLY: /[\d!=@#$%^&*()_+{}[\]:;<>,.?~\\-]/,
    LETTERS_WITH_HYPHEN: /[\d!=@#$%^&*()_+{}[\]:;<>,.?~\\]/,
    EMAIL: /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/,
    NUMBERS_ONLY: /[a-zA-Z!@#$%^&*()_+{}[\]:;<>,.?~\\]/,
    PHONE_NUMBER: /^\d{1,10}$/,
    WEBSITE: /^(https?:\/\/)?(www\.)?([a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)+)(\/[^\s]*)?$/,
    SENTENCE: /^[a-zA-Z0-9_&.,\-\s:;!]*$/,
    LETTERS_WITH_NUMBERS_AND_HYPHEN_ONLY: /^[a-zA-Z0-9- ]*$/,
    LETTERS_WITH_UNDERSCORE_AND_HYPHEN_ONLY: /^[a-zA-Z_-]*$/,
    LETTERS_WITH_UNDERSCORE_AND_HYPHEN_ONLY_WITH_SPACE: /^[a-zA-Z_-\s]+$/,
    LETTERS_WITH_UNDERSCORE_AND_HYPHEN_ONLY_WITH_SPACE_: /^[a-zA-Z_-\s]*$/,
    // LETTERS_WITH_UNDERSCORE_AMPERSAND_AND_HYPHEN_ONLY: /^[a-zA-Z_&\-\.\s]*$/,
    LETTERS_WITH_UNDERSCORE_AMPERSAND_AND_HYPHEN_ONLY: /^[a-zA-Z_&-\s]*$/,
    // LETTERS_WITH_UNDERSCORE_AMPERSAND_AND_HYPHEN_ONLY: /^[a-zA-Z_&-]*$/,
    ALPHA_NUMERIC_WITH_HYPHEN_SPACE_AND_EXCLAMATION: /^[a-zA-Z0-9\- '!]+$/,
}
